import { NAV_HEIGHT } from 'src/pages/consumer/components/DishFirstHeader/consts';
import { SecondaryButton } from 'src/shared/design-system/Buttons';
import { Col } from 'src/shared/design-system/Layout/Col';
import { Row } from 'src/shared/design-system/Layout/Row';
import { ifNotProp } from 'src/shared/styled-utils/ifNotProp';
import { ifProp } from 'src/shared/styled-utils/ifProp';
import { ZIndexes } from 'src/shared/ZIndexes';
import styled, { css } from 'styled-components';
import { Colors, Font, Mixins, ScreenWidth, Spacing } from 'web-common/src/shared/styles';
import { cartDropShadow } from './ConsumerOrderCart';

export const OrderOneTime = styled.div<{ isMultiCart: boolean }>`
  background-color: ${Colors.GRAY_LITE_30};
  ${ifNotProp(
    'isMultiCart',
    css`
      border-right: 1px solid ${Colors.GRAY_LITE_10};
    `
  )}

  ${cartDropShadow}
`;

export const MainRow = styled(Row)<{ isMultiCart: boolean }>`
  display: flex;

  @media (max-width: ${ScreenWidth.MEDIUM}) {
    flex-direction: column;
  }
`;

export const ContainerBackgroundColor = styled.div<{ showDatePicker: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  background-color: white;
  ${ifNotProp(
    'showDatePicker',
    css`
      @media only screen and (max-width: ${ScreenWidth.SMALL}) {
        background-color: unset;
      }
    `
  )}
`;

export const TopBorder = styled.div`
  border-top: 1px solid ${Colors.GRAY_LITE_10};
  width: max(calc(calc(100% - 1140px) / 2), 0px);
  height: 1px;
`;

export const MenuCol = styled(Col)<{ isMultiCart: boolean }>`
  ${(props) =>
    props.isMultiCart &&
    css`
      width: calc(100% - 400px);

      @media (max-width: ${ScreenWidth.LARGE}) {
        width: 100%;
      }
    `}
`;

export const DishSelectionWrapper = styled(Col)`
  background-color: unset;
`;

export const ShowMoreButtonRow = styled.div`
  display: flex;
  justify-content: center;
`;

export const ConsumerOrderCartCol = styled.div<{ isMultiCart: boolean; open: boolean }>`
  position: sticky;
  top: ${NAV_HEIGHT};
  padding: 0;
  ${(props) =>
    props.isMultiCart
      ? css`
          width: 400px;

          @media (max-width: ${ScreenWidth.SMALL}) {
            width: 100%;
            bottom: 0;
          }

          @media (min-width: 769px) and (max-width: ${ScreenWidth.LARGE}) {
            position: fixed;
            top: 0;
            right: 0;
            z-index: ${ZIndexes.SlideOutCart};
            transform: ${ifProp('open', 'translateX(0%)', 'translateX(100%)')};
            transition: width 0.2s ease, transform 0.2s ease;
          }
        `
      : css`
          width: 25%;
          @media (max-width: ${ScreenWidth.MEDIUM}) {
            width: 100%;
            bottom: 0;
          }
        `}
`;

export const ShowMoreButtonWrapper = styled(Col)``;
export const ShowMoreButton = styled(SecondaryButton)<{ hasReviews: boolean }>`
  width: 100%;
  padding: 0;
  margin-bottom: ${ifProp('hasReviews', 0, '36px')};
  @media (max-width: ${ScreenWidth.SMALL}) {
    margin-top: ${Spacing.SINGLE};
    margin-bottom: ${Spacing.SINGLE_HALF};
  }
`;

export const MessageButton = styled(SecondaryButton)`
  background: transparent;
  border: 2px solid ${Colors.RADISH};
  color: ${Colors.GRAY_DARK_20};
  margin: 0 15px ${Spacing.SINGLE} 15px;
  display: flex;
  font-weight: ${Font.Weight.BOLD};
  gap: ${Spacing.HALF};
  ${Mixins.Media.maxWidthSmall(`
    width: 100%;
  `)}
`;
